import React, { useEffect, useState } from "react";
import { API_BASE } from "../api";

function DeelnemersGallery() {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [photosLoading, setPhotosLoading] = useState(false);

  // Fetch participants on mount
  useEffect(() => {
    setLoading(true);
    fetch(`${API_BASE}/deelnemers`)
      .then((res) => res.json())
      .then((data) => {
        // Sort by registration time, most recent first
        const sorted = (data || []).sort(
          (a, b) =>
            new Date(b.registratietijd || b.created_at || 0) -
            new Date(a.registratietijd || a.created_at || 0)
        );
        setParticipants(sorted);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Fetch photos for selected participant
  useEffect(() => {
    if (!selected) return;
    setPhotosLoading(true);
    fetch(`${API_BASE}/photos?deelnemer_id=${encodeURIComponent(selected.id)}`)
      .then((res) => res.json())
      .then((data) => {
        setPhotos(data || []);
        setPhotosLoading(false);
      })
      .catch(() => setPhotosLoading(false));
  }, [selected]);

  const profileUrl = (p) =>
    p && p.profielfoto
      ? `${API_BASE}/uploads/${p.profielfoto}`
      : "https://via.placeholder.com/80?text=No+Photo";

  // Use storage_path for photo URL if present
  const photoUrl = (photo) => {
    if (!photo) return "https://via.placeholder.com/120?text=No+Photo";
    if (photo.storage_path && typeof photo.storage_path === "string") {
      return `${API_BASE}/${photo.storage_path.replace(/^\/+/, "")}`;
    }
    return "https://via.placeholder.com/120?text=No+Photo";
  };

  const handleDeletePhoto = async (photoId) => {
    if (!photoId) return;
    // Delete photo from backend
    try {
      await fetch(`${API_BASE}/photos/${photoId}`, {
        method: "DELETE",
      });
      // Remove from UI
      setPhotos((prev) => prev.filter((p) => p.id !== photoId));
    } catch (e) {
      // Optionally show error
    }
  };

  return (
    <div>
      <h2>Laatste deelnemers</h2>
      {loading ? (
        <div>Laden...</div>
      ) : (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1em",
            marginBottom: "2em",
          }}
        >
          {participants.map((p) => (
            <div
              key={p.id}
              style={{
                cursor: "pointer",
                textAlign: "center",
                width: 90,
              }}
              onClick={() => setSelected(p)}
              title={p.naam}
            >
              <img
                src={profileUrl(p)}
                alt={p.naam}
                style={{
                  width: 80,
                  height: 80,
                  objectFit: "cover",
                  borderRadius: "50%",
                  border:
                    selected && selected.id === p.id
                      ? "3px solid #007bff"
                      : "2px solid #ccc",
                  marginBottom: 4,
                }}
              />
              <div
                style={{
                  fontSize: "0.9em",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: 80,
                }}
              >
                {p.naam}
              </div>
            </div>
          ))}
        </div>
      )}

      {selected && (
        <div>
          <h4>
            Foto's van <span style={{ color: "#007bff" }}>{selected.naam}</span>
            <button
              style={{
                marginLeft: 16,
                fontSize: "0.9em",
                padding: "2px 8px",
                border: "1px solid #ccc",
                borderRadius: 4,
                background: "#f8f9fa",
                cursor: "pointer",
              }}
              onClick={() => setSelected(null)}
            >
              Terug
            </button>
          </h4>
          {photosLoading ? (
            <div>Foto's laden...</div>
          ) : photos.length === 0 ? (
            <div>Geen foto's gevonden.</div>
          ) : (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "1em",
                marginTop: "1em",
              }}
            >
              {photos.map((photo) => (
                <div
                  key={photo.id}
                  style={{
                    border: "1px solid #eee",
                    borderRadius: 8,
                    padding: 8,
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  <img
                    src={photoUrl(photo)}
                    alt={`photo ${photo.id}`}
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      borderRadius: 6,
                      marginBottom: 6,
                    }}
                  />
                  <br />
                  <button
                    style={{
                      background: "#dc3545",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      padding: "4px 10px",
                      cursor: "pointer",
                      fontSize: "0.9em",
                    }}
                    onClick={() => handleDeletePhoto(photo.id)}
                  >
                    Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default DeelnemersGallery;
